import React from 'react';

import cn from 'classnames';
import Image from 'next/legacy/image'

import { store } from '@store/index';
import { getRate } from '@utils/getRate';
import helper from '@utils/helper';
import I18n from '@utils/i18n'
import { getListDataCurrentData, getRateSymbol } from '@widget/market/TradeList/utils';

import styles from './index.module.css';

const Item = ({ label, value }) => {
  return (
    <div className={styles.row}>
      <span className={styles.label}>{label}</span>
      <div className={cn(styles.value, 'DINPro-Medium')}>{value}</div>
    </div>
  )
}

export const Synopsis = (props) => {
  const { coinCode, name, ranking, marketValue, circulatingSupply, currency, maxSupply, picturePath, totalSupply, officialWebsite, introductionEn, introductionHk, introductionZh, showKeepDecimalForCoin } = props;
  const rateType = getRate();
  const { coinDetail, otherRateDetail } = store.marketStore;
  const rateTypeSymbol = getRateSymbol(rateType)
  const marketValueCacl = getListDataCurrentData({
    coinDetail,
    rateType,
    coinArr: [coinCode],
    priceLast: marketValue,
    precision: showKeepDecimalForCoin,
    otherRateDetail
  });
  return (
    <div className={styles.wrapper}>
      <Item
        label={<h3>{I18n.t('asset_coin')}</h3>}
        value={(
          <>
            <div className={styles.img}>
              {picturePath && <Image src={picturePath} alt="" width={20} height={20} />}
            </div>
            <span className={cn(styles.coinCode, 'DINPro-Medium')}>{coinCode || '--'}</span>
            <span className={cn(styles.name, 'DINPro')}>{name || '--'}</span>
          </>
        )}
      />
      <Item label={<h4>{I18n.t('lottery_rank')}</h4>} value={`NO.${ranking || '--'}`} />
      <Item label={<h4>{I18n.t('marketCap')}</h4>} value={`${rateTypeSymbol} ${marketValue ? helper.addCommaToThousands(marketValueCacl) : '--'}`} />
      <Item label={<h4>{I18n.t('circulatingSupply')}</h4>} value={`${circulatingSupply ? helper.addCommaToThousands(circulatingSupply) : '--'} ${currency || ''}`} />
      <Item label={<h4>{I18n.t('maxSupply')}</h4>} value={`${maxSupply ? helper.addCommaToThousands(maxSupply) : '--'}`} />
      <Item label={<h4>{I18n.t('totalSupply')}</h4>} value={`${totalSupply ? helper.addCommaToThousands(totalSupply) : '--'}`} />
      <Item label={<h4>{I18n.t('officialWebsite')}</h4>} value={<a className={cn(styles.a, 'DINPro-Medium')} href={officialWebsite} target="_blank" rel="noreferrer" >{officialWebsite ?? '--'}</a>} />
      <h4 className={cn(styles.title, 'DINPro-Medium')}>{I18n.t('profile_my_profile_status')}</h4>
      <p className={styles.content}>{I18n.locale === 'zh-CN' ? introductionZh : I18n.locale === 'zh-TC' ? introductionHk : introductionEn}</p>
    </div>
  )
}
